import { ApiService } from "./apiService";

export const checkWhatsapp = async () => {
  const response = await ApiService.get(
    `waha/check?session=default`,
    { responseType: "blob" }
  );

  return response;
};
